import store from "@/store"
import { getBydomainName } from "@/api/autoweb"
export function setHeaderIcon(url) {
  var link = document.createElement("link")
  link.type = "image/x-icon"
  link.rel = "icon"
  link.href = url
  document.getElementsByTagName("head")[0].appendChild(link)
}
// const currentOrigin = process.env.NODE_ENV === 'development' ? 'http://medpro.ydmob.com' : location.origin
// getBydomainName({
//   domainName: currentOrigin
// }).then(res => {
//   store.dispatch('setWebInfo', res.data)
// })

function fetchWebInfo(domainName, language) {
  return getBydomainName({ domainName })
    .then(async (res) => {
      const { data = {} } = res
      store.dispatch("setWebInfo", { data, language })
      return res.data
    })
    .catch((error) => {
      console.error("获取网站信息失败:", error)
      throw error
    })
}

export function initWebInfo(language = "zh") {
  const currentOrigin =
    process.env.NODE_ENV === "development"
      ? "http://medpro.ydmob.com"
      : location.origin

  return fetchWebInfo(currentOrigin, language)
}
